import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { logo } from "../../assets";
import { IoIosMenu, IoMdClose } from "react-icons/io";
import { AddProduct } from "../admin";
import { Test } from "../Test";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.includes('/admin')

  return (
    <nav className="py-4 bg-primary  mx-auto fixed top-0 w-full z-50">
      <div className="text-white container flex flex-row justify-between items-center">
        <div className="w-1/3">
          <Link to={"/"}>
            <img src={logo} alt="logo" className="w-[80px]" />
          </Link>
        </div>
        <div className="hidden md:flex w-2/3">
          <ul className="flex flex-row gap-10 text-lg">
            {isAdmin ?
              <>
                <li className="hover:border-b border-b-white">
                  <Link to="/admin">Add Product</Link>
                </li>
                <li className="hover:border-b border-b-white">
                  <Link to="/admin/add-question">Add Question</Link>
                </li>
                <li className="hover:border-b border-b-white">
                  <Link to="/admin/products">Products</Link>
                </li>
                <li className="hover:border-b border-b-white">
                  <Link to="/admin/question">Question</Link>
                </li>
              </> :
              <li className="hover:border-b border-b-white">
                <Link to="/">Test</Link>
              </li>
            }

          </ul>
        </div>

        <div className="md:hidden w-2/3 flex justify-end">
          {!toggleMenu ? (
            <IoIosMenu
              onClick={() => setToggleMenu(true)}
              className="text-4xl"
            />
          ) : (
            <IoMdClose
              onClick={() => setToggleMenu(false)}
              className="text-4xl"
            />
          )}
        </div>
      </div>
      {toggleMenu && (
        <div
          className={`md:hidden p-4 bg-primary text-white shadow-md ${toggleMenu ? "fixed right-0 w-[70%] h-screen p-4" : "hidden"
            }`}
        >
          <ul className="flex flex-col gap-5 text-lg text-start px-5">
            {isAdmin ?
              <>
                <li
                  className="hover:border-b border-b-white"
                  onClick={() => setToggleMenu(false)}
                >
                  <Link to="/admin">Add Product</Link>
                </li>
                <li
                  className="hover:border-b border-b-white"
                  onClick={() => setToggleMenu(false)}
                >
                  <Link to="/admin/add-question">Add Question</Link>
                </li>
                <li
                  className="hover:border-b border-b-white"
                  onClick={() => setToggleMenu(false)}
                >
                  <Link to="/admin/products">Products</Link>
                </li>
                <li
                  className="hover:border-b border-b-white"
                  onClick={() => setToggleMenu(false)}
                >
                  <Link to="/admin/question">Question</Link>
                </li>
              </>
              :

              <li
                className="hover:border-b border-b-white"
                onClick={() => setToggleMenu(false)}
              >
                <Link to="/test">Test</Link>
              </li>
            }
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
